// src/extenders/banner-animation.js
var BannerAnimation = class extends HTMLElement {
  constructor() {
    super();
    const moveTextOverImage = () => {
      const outerAnimationElement = this;
      const animationText = this.querySelector(".animation-text");
      const outerElementPosition = outerAnimationElement.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const treshold = 160;
      const opacity = (treshold - window.scrollY) / treshold;
      if (outerElementPosition.bottom <= windowHeight) {
        animationText.style.bottom = `-${window.scrollY}px`;
        animationText.style.opacity = opacity;
      } else {
        animationText.style.bottom = 0;
        animationText.style.opacity = 1;
      }
    };
    window.addEventListener("scroll", () => moveTextOverImage());
  }
};
if (customElements.get("banner-animation") === void 0) {
  customElements.define("banner-animation", BannerAnimation);
}
var banner_animation_default = BannerAnimation;
export {
  banner_animation_default as default
};
